import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common'

@Component({
  selector: 'app-page403',
  templateUrl: './page403.component.html',
  styleUrls: ['./page403.component.scss']
})

/**
 * PAges-404 component
 */
export class Page403Component implements OnInit {

  constructor(
    private location: Location
  ) { }

  ngOnInit(): void {
  }
  backToPrevious() {
    this.location.back();
  }
}
